"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var isWebView = function isWebView() {
  return window.location.href.includes("/in-app-view");
};

var _default = isWebView;
exports["default"] = _default;